import React from 'react';
import { GenerationHistory } from '../generations/GenerationHistory';
import { useLocation } from '../../hooks/useLocation';
import { Link } from '../common/Link';
import { FileText } from 'lucide-react';

export function Dashboard() {
  const { pathname } = useLocation();

  const renderContent = () => {
    switch (pathname) {
      case '/dashboard/history':
        return (
          <div className="w-full p-6 lg:p-8">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold">Generation History</h1>
              <Link
                href="/generator"
                className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-hover transition-colors"
              >
                <FileText className="w-5 h-5 mr-2" />
                New Job Kit
              </Link>
            </div>
            <GenerationHistory />
          </div>
        );
      default:
        return (
          <div className="w-full p-6 lg:p-8">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-2xl font-bold">Generation History</h1>
              <Link
                href="/generator"
                className="inline-flex items-center px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-hover transition-colors"
              >
                <FileText className="w-5 h-5 mr-2" />
                New Job Kit
              </Link>
            </div>
            <GenerationHistory />
          </div>
        );
    }
  };

  return renderContent();
}